import React, { Fragment } from "react";
import { Dialog, DialogTitle, IconButton } from "@mui/material";
import "./style.css";

const BlogSingle = ({
  maxWidth,
  open,
  onClose,
  title,
  bImg,
  create_at,
  author,
  comment,
  mediaRedirectLink,
}) => {
  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        className="modalWrapper quickview-dialog"
        maxWidth={maxWidth || "md"}
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              textTransform: "uppercase",
              letterSpacing: "1px",
              color: "#888",
            }}
          >
            {create_at}
          </span>
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
            sx={{ color: "#555" }}
          >
            <i className="ti-close" style={{ fontSize: "14px" }}></i>
          </IconButton>
        </DialogTitle>

        <div className="blog-single-modal-body">
          {bImg && (
            <div className="blog-single-modal-img">
              <img src={bImg} alt={title} />
            </div>
          )}
          <div className="blog-single-modal-content">
            <h2 className="blog-single-modal-title">{title}</h2>
            <p className="blog-single-modal-meta">By {author}</p>
            <a
              href={mediaRedirectLink}
              target="_blank"
              className="theme-btn blog-single-modal-cta"
            >
              {comment || "Read More"}
            </a>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};

export default BlogSingle;
